import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDrizzleThunderstorm: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path
        d="M57.9669 68L53.1113 81.3222H57.8447L62.6891 68H57.9669Z"
        fill="#87D6F8"
      />
      <path
        d="M38.6111 68L37 72.4333H41.7333L43.3444 68H38.6111Z"
        fill="#87D6F8"
      />
      <path
        d="M48.2902 68L46.668 72.4333H51.4013L53.0124 68H48.2902Z"
        fill="#87D6F8"
      />
      <path
        d="M45.0564 76.9111L43.4453 81.3334H48.1675L49.7786 76.9111H45.0564Z"
        fill="#87D6F8"
      />
      <path
        d="M79.5531 43.7185C78.33 43.2136 76.9723 42.9331 75.5584 42.9331H70.4304V37.951C70.4304 29.6923 65.2576 22.6006 57.8966 19.5709C55.4392 18.5611 52.7461 18 49.9072 18C40.3581 18 32.4025 24.3735 30.1134 32.9576H29.384C20.8897 32.9576 14 39.6565 14 47.9152C14 54.1092 17.8825 59.428 23.4032 61.7058C25.2434 62.4576 27.2745 62.884 29.3952 62.884H34.5232H65.3024H75.5584C81.2251 62.884 85.8144 58.4181 85.8144 52.9086C85.8144 48.7792 83.2336 45.2334 79.5531 43.7185Z"
        fill="#87D6F8"
      />
    </svg>
  )
}

export default WeatherIconDrizzleThunderstorm
